exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customer-sign-document .opaque{background:var(--theme-bg-color)}.customer-sign-document__pad{margin:30px auto;border:2px solid var(--theme-grey-disabled);border-radius:2px}.customer-sign-document__buttons{padding-bottom:125px}.customer-sign-document__buttons button{margin:auto 15px}.customer-sign-document__sticky{position:fixed;bottom:40px;width:100%;left:0;display:flex;align-items:center;justify-content:center;flex-flow:row nowrap;z-index:0}", ""]);

// exports
